import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

export default function ReviewQueueSkeleton() {
    const rows = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; // 10 rows

    return (
        <Box sx={{ mt: 0, display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
            <Box sx={{
                flex: 1,
                overflow: 'hidden',
                pr: 2,
                minHeight: 0
            }}>
                {/* Header Skeleton */}
                <Box sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "minmax(200px,1fr) 140px 160px 140px",
                        sm: "minmax(300px,1fr) 160px 180px 160px",
                        md: "minmax(400px,1fr) 180px 200px 180px",
                        lg: "minmax(450px,1fr) 180px 200px 180px"
                    },
                    alignItems: "center",
                    height: 48,
                    background: '#fff',
                    borderBottom: '1px solid #EEF2F6',
                    mb: 1
                }}>
                    {[1, 2, 3, 4].map((_, index) => (
                        <Skeleton key={index} variant="text" width={index === 0 ? "40%" : "60%"} height={20} animation="wave" />
                    ))}
                </Box>

                {/* Rows Skeleton */}
                {rows.map((row) => (
                    <Box
                        key={row}
                        sx={{
                            display: "grid",
                            gridTemplateColumns: {
                                xs: "minmax(200px,1fr) 140px 160px 140px",
                                sm: "minmax(300px,1fr) 160px 180px 160px",
                                md: "minmax(400px,1fr) 180px 200px 180px",
                                lg: "minmax(450px,1fr) 180px 200px 180px"
                            },
                            alignItems: "center",
                            height: 64,
                            borderBottom: "1px solid #EEF2F6",
                        }}
                    >
                        {/* Title */}
                        <Skeleton variant="text" width="70%" height={24} animation="wave" />

                        {/* Status */}
                        <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 1 }} animation="wave" />

                        {/* Contributor */}
                        <Skeleton variant="text" width="60%" height={24} animation="wave" />

                        {/* Date */}
                        <Skeleton variant="text" width="50%" height={24} animation="wave" />
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
